import React from 'react'
import styles from './styles.module.css'
import { Dropzone } from 'shared/dropzone'

export const ProfilePictureUpload = ({ error }: { error: string }) => {
  return (
    <>
      <Dropzone
        accept={['image/jpg', 'image/jpeg', 'image/tif', 'image/tiff', 'image/png']}
        multiple={false}
        maxSize={20000000}
        name="fundraising_event[profile_picture]"
        hasFormError={error !== '[]'}
        hasInlinePreviewWithFixedRatio={true}
      />
      {error !== '[]' && (
        <span className="invalid-feedback block">
          {i18n.t('fundraising_events.manage.profile_picture_upload.errors.blank')}
        </span>
      )}
      <span className={styles.croppingHint}>
        {i18n.t(`fundraising_events.manage.profile_picture_upload.cropping_hint`)}
      </span>
    </>
  )
}
